import _ from 'lodash';
import api from '../../../api';
import helper from '../../../helper';

const actions = {
  getSPDataAndSetIndicators({ state, commit, rootState }, indicators) {
    if (indicators.length) {
      commit('setLoadingSPData', true);
      // clear out the state of the existing panels
      commit('resetPanels');
      // destroy existing panels so panel state gets rebuilt when panels
      // are created fresh
      commit('setIndicators', []);
      if (!rootState.flags.initialPageLoad) {
        // reset to show footnotes (default)
        commit('setShowFootnotes', true);
      }
      const indicatorIdsCsv = _(indicators).map('id').value().join(',');
      api.get(`SPData/${state.GSGo.locationId}/${indicatorIdsCsv}`)
        .then((response) => {
          let spDataKeyedByIndicatorId;
          const indicatorIds = _(indicators).map('id').uniq().value();
          const missingIdDataErrors =
            helper.checkForMissingLookupIdsFromRawSPData(
              rootState.lku,
              rootState.dataTypes,
              indicatorIds,
              response.data,
            );
          const duplicateIdDataErrors =
            helper.checkForDuplicateSPDataRows(response.data);
          const dataErrors = missingIdDataErrors.concat(duplicateIdDataErrors);
          if (dataErrors.length) {
            dataErrors.forEach((error) => {
              commit('addDataError', error, { root: true });
            });
            spDataKeyedByIndicatorId = {};
          } else {
            const spDataRaw =
              helper.addMultistratRowsAndStratCatColumns(response.data, rootState.lku);
            const spDataIndicatorIds = _(indicators).map('id').uniq().value();
            spDataKeyedByIndicatorId = _(spDataIndicatorIds).reduce((acc, qi) => {
              acc[qi] = _(spDataRaw).filter({ qi }).value();
              return acc;
            }, {});
          }
          commit('setIndicators', indicators);
          commit('setSPData', spDataKeyedByIndicatorId);
          commit('setLoadingSPData', false);
        })
        .catch((err) => {
          commit('setSPData', false);
          commit('addApiError', err, { root: true });
        });
    } else {
      commit('setIndicators', []);
      commit('setSPData', []);
    }
  },
};

export default actions;



// WEBPACK FOOTER //
// ./src/store/modules/SP/actions.js